import { Question } from '_/services/models/forms.model';

interface IFieldsToCheck {
  form: Question[];
  showCustomFields: boolean;
}

export const sortedFields = (questions: Question[]) => {
  const sortedQuestions = questions.sort((a, b) => {
    const sortA = a.order ?? Infinity;
    const sortB = b.order ?? Infinity;
    return sortA - sortB;
  });
  return sortedQuestions;
};

export const fieldsToCheck = ({ form, showCustomFields }: IFieldsToCheck) => {
  const fieldsToCheck = form.map(({ label, value, required }) => ({
    label,
    value,
    required,
  }));

  const showError = fieldsToCheck.some(({ label, value, required }) => {
    return !!label && !value && (required ?? true) && showCustomFields;
  });

  return showError;
};
